import { useEffect, useId, useRef, useState } from 'preact/hooks';

/** “Discard changes”, with a confirmation: puts a published event back to what families see. */
export function DiscardChanges({ disabled, onDiscard }: { disabled?: boolean; onDiscard: () => Promise<boolean> }) {
  const id = useId();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const cancel = useRef<HTMLButtonElement>(null);
  useEffect(() => { if (confirming) { dialog.current?.showModal(); cancel.current?.focus({ preventScroll: true }); } }, [confirming]);
  const dismiss = () => {
    if (busy) return;
    dialog.current?.close(); setConfirming(false); trigger.current?.focus({ preventScroll: true });
  };
  const discard = async () => {
    setBusy(true); setError(null);
    const done = await onDiscard();
    setBusy(false);
    if (done) { dialog.current?.close(); setConfirming(false); }
    else setError('Could not discard your changes. Check your connection and try again.');
  };
  return <>
    <button type="button" class="secondary" ref={trigger} disabled={disabled} onClick={() => { setError(null); setConfirming(true); }}>Discard changes</button>
    {confirming && <dialog class="event-delete-dialog" ref={dialog} aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
      onCancel={(event) => { event.preventDefault(); dismiss(); }}>
      <h2 id={`${id}-title`}>Discard your changes?</h2>
      <p id={`${id}-description`}>The event goes back to what families see now. Changes made since it was published can’t be recovered.</p>
      {error && <p class="alert" role="alert">{error}</p>}
      <div class="event-delete-actions">
        <button type="button" class="secondary" ref={cancel} disabled={busy} onClick={dismiss}>Keep changes</button>
        <button type="button" class="danger-solid" disabled={busy} onClick={() => { void discard(); }}>{busy ? 'Discarding…' : 'Discard changes'}</button>
      </div>
    </dialog>}
  </>;
}
